var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrowShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.669 18.795C11.4581 19.0057 11.1721 19.124 10.874 19.124C10.5759 19.124 10.2899 19.0057 10.079 18.795L3.70401 12.42C3.49333 12.2091 3.375 11.9231 3.375 11.625C3.375 11.3269 3.49333 11.041 3.70401 10.83L10.079 4.45502C10.2924 4.2564 10.5745 4.14825 10.866 4.15328C11.1574 4.15832 11.4356 4.27615 11.642 4.48201C11.8479 4.68842 11.9657 4.96659 11.9707 5.25807C11.9758 5.54955 11.8676 5.83162 11.669 6.04501L7.21401 10.5L18.374 10.5C18.6724 10.5 18.9585 10.6185 19.1695 10.8295C19.3805 11.0405 19.499 11.3266 19.499 11.625C19.499 11.9234 19.3805 12.2095 19.1695 12.4205C18.9585 12.6315 18.6724 12.75 18.374 12.75H7.21401L11.669 17.205C11.8797 17.416 11.998 17.7019 11.998 18C11.998 18.2981 11.8797 18.5841 11.669 18.795Z",
    fill: "#181038"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrowShort);
export default __webpack_public_path__ + "static/media/left-arrow-short.7a3d7ed520e0e6eebdfc5109feb50ee6.svg";
export { ForwardRef as ReactComponent };